import { createFileRoute } from '@tanstack/react-router';
import { LoginPage } from '#web/auth/LoginPage';

export const Route = createFileRoute('/login')({
  component: LoginPage,
});
